import { useQuery } from '@apollo/client';
// import { useMutation } from '@apollo/client';
import { ClickAwayListener, makeStyles, Theme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { ReactComponent as SearchIcon } from 'assets/svg/searchWhite.svg';
import CustomLayout from 'component/layout/custom_layout';
import UserType from 'constants/user';
import { AlgoliaInput, AlgoliaResponse } from 'graph_ql/types/types';
import { GET_USERS } from 'graph_ql/users/queries';
import { IAlgoliaUser } from 'graph_ql/users/types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getUserProfilePhoto } from 'utils/getUserProfilePhoto';
import { get } from 'lodash';
import { cache } from 'graph_ql';
import themes from 'styles/themes';
// import { GET_MY_SESSIONS } from 'graph_ql/styling_session/queries';
// import { MySessionsType } from 'containers/my_sessions/types';
// import { ReactComponent as ArrowDown } from 'assets/svg/arrowDown.svg';
// import { ReactComponent as ArrowUp } from 'assets/svg/arrowUp.svg';
import moment from 'moment';
import { SessionSuggestion, UserSuggestion } from '../type';
// import {
//     CREATE_STYLING_SESSION_OUTCOME,
//     DELETE_STYLING_SESSION_OUTCOME,
// } from 'graph_ql/styling_session_outcomes/mutations';
import { StylingSessionOutcomeType } from 'containers/session_details/type';
import { GET_STYLING_SESSION_OUTCOMES } from 'graph_ql/styling_session_outcomes/queries';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export interface StyleProps {
    isShowOptions: boolean;
    suggestionsHeight: number;
    // isShowSessions: boolean;
    // sessionSuggestionsHeight: number;
}
const useStyles = makeStyles<Theme, StyleProps>(() => ({
    optionsContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        justifyContent: 'space-between',
        overflowY: 'scroll',
    },
    unlistedBox: {
        color: themes.palette.primary.main,
        padding: 24,
        paddingBottom: 0,
    },
    label: {
        fontSize: '14px',
    },
    searchBox: {
        marginTop: 22,
        borderBottom: '1px solid',
        paddingBottom: 10,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    buttonPublishBox: {
        '@media (min-width: 1024px)': {
            position: 'absolute',
        },
        width: 'auto',
        left: 0,
        right: 0,
        zIndex: 100,
        bottom: 0,
        padding: 24,
        WebkitTransition: 'all .35s ease-in-out',
        transition: 'all .35s ease-in-out',
    },
    buttonPublish: {
        width: '100%',
        height: '48px',
        padding: '0',
        textAlign: 'center',
        color: themes.palette.common.white,
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        border: 'none',
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:disabled': {
            backgroundColor: '#b5b5b5',
        },
    },
    input: {
        padding: '0px',
        width: '100%',
        paddingLeft: '14px',
        background: 'transparent',
        border: 'none',
        borderBottom: 'none !important',
        color: themes.palette.primary.main,
        fontSize: '16px',
        borderRadius: 0,
        outline: 'none !important',
    },
    suggestions: {
        display: ({ isShowOptions }) => (isShowOptions ? 'block' : 'none'),
        position: 'absolute',
        backgroundColor: 'white',
        zIndex: 100000,
        overflowY: 'auto',
        top: '48px',
        left: '0',
        right: '0',
        borderRadius: '8px',
        height: ({ suggestionsHeight }) => `${suggestionsHeight ? suggestionsHeight * 36 : 36}px`,
        maxHeight: `350px`,
        padding: '8px 8px 0px',
    },
    suggestionItem: {
        display: 'flex',
        paddingBottom: 12,
        cursor: 'pointer',
    },
    suggestionAvatar: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
    },
    suggestionTitle: {
        color: themes.palette.primary.main,
        fontSize: 14,
        flex: 1,
        paddingLeft: 12,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    noSuggestions: {
        color: themes.palette.primary.main,
        width: '100%',
        textAlign: 'center',
    },
    selectedOptions: {
        padding: '24px 0px 0',
        overflowY: 'scroll',
        height: '100%',
        maxHeight: 220,
    },
    selectedOptionItem: {
        display: 'flex',
        paddingBottom: 12,
    },
    selectedOptionTitle: {
        color: themes.palette.primary.main,
        fontSize: 14,
        flex: 1,
        paddingLeft: 12,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    // sessionsSearchBox: {
    //     borderBottom: '1px solid',
    //     display: 'flex',
    //     alignItems: 'center',
    //     position: 'relative',
    //     width: '100%',
    // },
    // sessionSearchBoxItems: {
    //     width: '100%',
    //     display: 'flex',
    //     justifyContent: 'space-between',
    //     alignItems: 'center',
    // },
    // sessionSuggestions: {
    //     display: ({ isShowSessions }) => (isShowSessions ? 'block' : 'none'),
    //     position: 'absolute',
    //     backgroundColor: 'white',
    //     zIndex: 100000,
    //     overflowY: 'auto',
    //     top: '48px',
    //     left: '0',
    //     right: '0',
    //     borderRadius: '8px',
    //     height: ({ sessionSuggestionsHeight }) => `${sessionSuggestionsHeight ? sessionSuggestionsHeight * 100 : 36}px`,
    //     maxHeight: `350px`,
    //     padding: '8px 8px 20px',
    // },
    // sessionSuggestionTitle: {
    //     color: themes.palette.primary.main,
    //     fontSize: 14,
    //     flex: 1,
    //     whiteSpace: 'nowrap',
    //     overflow: 'hidden',
    //     textOverflow: 'ellipsis',
    // },
    // sessionSuggestionItem: {
    //     display: 'flex',
    //     paddingBottom: 12,
    //     cursor: 'pointer',
    // },
    // sessionSuggestionDate: {
    //     marginTop: 8,
    //     color: '#484848',
    //     fontSize: 10,
    // },
    // sessionSuggestionReason: {
    //     color: '#A3A3A3',
    //     fontSize: 12,
    // },
    // sessionSuggestionItemBottom: {
    //     paddingLeft: 8,
    //     flex: 1,
    // },
}));
const PublishToConsumers = (props) => {
    const [valueSearch, setValueSearch] = useState('');
    const [selectedOptions, setSelectedOptions] = useState<UserSuggestion[]>(
        props.consumers.length ? props.consumers : [],
    );
    const [suggestions, setSuggestions] = useState<UserSuggestion[]>([]);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [isShowOptions, setIsShowOptions] = useState<boolean>(false);
    // const [isShowSessions, setIsShowSessions] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(0);
    // const [sessionCurrentPage, setSessionCurrentPage] = useState<number>(0);
    const getMoreTimeout = useRef<any>(null);
    // const [hasMoreSessions, setHasMoreSessions] = useState<boolean>(true);
    // const [sessionSuggestions, setSessionSuggestions] = useState<SessionSuggestion[]>([]);
    const [selectedSessions, setSelectedSelectedSessions] = useState<SessionSuggestion[]>([]);
    const user = useSelector((state: RootState) => state.userDetail.me);
    const storeCondition = user.stores
        ? user.stores.reduce((condition, store) => {
            if (store) {
                condition += condition === '' ? `storeIds:${store.id}` : ` OR storeIds:${store.id}`;
            }
            return condition;
        }, '')
        : '';

    const getUserVariables = useMemo(() => {
        cache.modify({
            fields: {
                algoliaGetUsers(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        return {
            query: valueSearch,
            filters: `userType:${UserType.Customer}${storeCondition === '' ? '' : ' AND (' + storeCondition + ')'}`,
            page: 0,
            hit: 20,
        };
        // eslint-disable-next-line
    }, [valueSearch]);
    const { fetchMore: fetchUsers } = useQuery<AlgoliaResponse<IAlgoliaUser, 'algoliaGetUsers'>, AlgoliaInput>(
        GET_USERS,
        {
            variables: getUserVariables,
            fetchPolicy: 'network-only',
            onCompleted(res) {
                if (!res) return;
                onGetUsers(res, false);
            },
        },
    );
    const onGetUsers = (res, fetch) => {
        if (get(res, ['algoliaGetUsers', 'hits'], []).length) {
            const data = res.algoliaGetUsers.hits.map((item) => {
                return {
                    id: item.id,
                    fullName: `${item.firstName} ${item.lastName}`,
                    avatar: getUserProfilePhoto(item),
                };
            });
            if (res.algoliaGetUsers.page >= res.algoliaGetUsers.nbPages - 1) setHasMore(false);
            else {
                setHasMore(true);
                setCurrentPage(res?.algoliaGetUsers?.page);
            }
            if (fetch) setSuggestions((prev) => [...(prev || []), ...(data || [])]);
            else setSuggestions(data);
        } else {
            setSuggestions([]);
            setHasMore(false);
        }
    };

    useEffect(() => {
        setCurrentPage(0);
        // setSessionCurrentPage(0);
    }, []);
    const onChangeInput = (e: any) => {
        setValueSearch(e?.target?.value);
    };

    const fetchMoreData = async (page) => {
        const data = await fetchUsers({
            variables: {
                page,
                hit: 20,
            },
        });
        onGetUsers(data?.data, true);
    };
    useEffect(() => {
        if (renderItemSuggestions(suggestions, selectedOptions).length === 0 && hasMore) {
            setCurrentPage((prev) => prev + 1);
            if (getMoreTimeout.current) {
                clearTimeout(getMoreTimeout.current);
            }
            getMoreTimeout.current = setTimeout(() => {
                fetchMoreData(currentPage + 1);
            }, 1500);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasMore, selectedOptions]);

    const onSelectOption = (option) => {
        const data = [...selectedOptions, option];
        setSelectedOptions(data);
        props.setConsumersIds(data.map((item) => item.id));
        setValueSearch('');
    };

    const handleDeleteItem = (option) => {
        const data = selectedOptions.filter((item) => item?.id !== option?.id);
        setSelectedOptions(data);
        props.setConsumersIds(data.map((item) => item.id));
    };

    const renderItemSuggestions = (suggestions: any[], selected: any[]) => {
        const newArr: any[] = [];
        for (let suggestion of suggestions) {
            if (selected.findIndex((item) => item.id === suggestion.id) === -1) {
                newArr.push(suggestion);
            }
        }
        return newArr;
    };

    useQuery(GET_STYLING_SESSION_OUTCOMES, {
        fetchPolicy: 'cache-and-network',
        variables: {
            input: {
                styleId: props?.styleId!,
                type: StylingSessionOutcomeType.Style,
            },
        },
        onCompleted(response) {
            const data = response?.getStylingSessionOutcomes?.map((outcome) => {
                return {
                    id: outcome?.stylingSession?.id,
                    sessionOutcomeId: outcome?.id,
                    taffiId: outcome?.stylingSession?.taffiId,
                    customerId: outcome?.stylingSession?.customer?.id,
                    customerFullName: `${outcome?.stylingSession?.customer?.firstName} ${outcome?.stylingSession?.customer?.lastName}`,
                    customerAvatar: getUserProfilePhoto(outcome?.stylingSession?.customer),
                    startTime: moment(outcome?.stylingSession?.startTime).format('ll'),
                    stylingSessionReason: `${outcome?.stylingSession?.stylingSessionReason?.value} ${
                        Boolean(outcome?.stylingSession?.subReason?.length)
                            ? `, ${
                                outcome?.stylingSession?.subReason?.length > 30
                                    ? outcome?.stylingSession?.subReason.substring(0, 70) + '...'
                                    : outcome?.stylingSession?.subReason
                            }`
                            : ''
                    }`,
                };
            });
            setSelectedSelectedSessions([...selectedSessions, ...data]);
        },
        onError(error) {
            console.error('get styling session outcomes Failed: ', error);
        },
    });

    // const [deleteStylingSessionOutCome] = useMutation(DELETE_STYLING_SESSION_OUTCOME);

    // const { fetchMore: fetMoreMySessions } = useQuery(GET_MY_SESSIONS, {
    //     fetchPolicy: 'cache-first',
    //     variables: {
    //         input: {
    //             type: MySessionsType.COMPLETED,
    //             paging: {
    //                 size: 20,
    //                 page: 0,
    //             },
    //         },
    //     },
    //     onCompleted(response) {
    //         if (response?.getMySessions?.data?.length) {
    //             const { paging } = response.getMySessions;
    //             const data = response?.getMySessions?.data?.map((session) => {
    //                 return {
    //                     id: session?.id,
    //                     taffiId: session?.taffiId,
    //                     customerId: session?.customer?.id,
    //                     customerFullName: `${session?.customer?.firstName} ${session?.customer?.lastName}`,
    //                     customerAvatar: getUserProfilePhoto(session?.customer),
    //                     startTime: moment(session?.startTime).format('ll'),
    //                     stylingSessionReason: `${session?.stylingSessionReason?.value} ${
    //                         Boolean(session?.subReason?.length)
    //                             ? `, ${
    //                                 session?.subReason?.length > 30
    //                                     ? session?.subReason.substring(0, 70) + '...'
    //                                     : session?.subReason
    //                             }`
    //                             : ''
    //                     }`,
    //                 };
    //             });
    //             setSessionSuggestions([...sessionSuggestions, ...data]);
    //             setSessionCurrentPage(paging?.page);
    //         } else {
    //             setHasMoreSessions(false);
    //         }
    //     },
    // });

    // const onSelectSession = (option: SessionSuggestion) => {
    //     const data = [...selectedSessions, option];
    //     setSelectedSelectedSessions(data);
    //     props.setConsumersIds(data.map((item) => item?.customerId));
    // };

    // const [createStylingSessionOutcome] = useMutation(CREATE_STYLING_SESSION_OUTCOME);

    // const handleDeleteSession = (session: SessionSuggestion) => {
    //     const data = selectedSessions.filter((item) => item?.id !== session?.id);
    //     setSelectedSelectedSessions(data);
    //     props.setConsumersIds(data.map((item) => item.id));
    //     if (session?.sessionOutcomeId) {
    //         deleteStylingSessionOutCome({
    //             variables: {
    //                 input: {
    //                     id: session?.sessionOutcomeId,
    //                 },
    //             },
    //         });
    //     }
    // };

    // const fetchMoreSessions = (page: number) => {
    //     fetMoreMySessions({
    //         variables: {
    //             input: {
    //                 type: MySessionsType.COMPLETED,
    //                 paging: {
    //                     size: 20,
    //                     page: page,
    //                 },
    //             },
    //         },
    //     });
    // };

    const handlePublishPrivate = () => {
        // if (selectedSessions?.length) {
        //     selectedSessions?.forEach((session) => {
        //         if (!session?.sessionOutcomeId) {
        //             createStylingSessionOutcome({
        //                 variables: {
        //                     input: {
        //                         consumerId: session?.customerId,
        //                         sessionTaffiId: session?.taffiId,
        //                         type: StylingSessionOutcomeType.Style,
        //                         styleId: props?.styleId,
        //                         productTaffiId: props?.styleTaffiId,
        //                     },
        //                 },
        //             });
        //         }
        //     });
        // }
        props.onPublish();
    };

    const classes = useStyles({
        isShowOptions,
        // isShowSessions,
        suggestionsHeight: renderItemSuggestions(suggestions, selectedOptions).length,
        // sessionSuggestionsHeight: renderItemSuggestions(sessionSuggestions, selectedSessions).length,
    });

    return (
        <CustomLayout
            title="Publish to Consumer"
            hideBottomNav={true}
            headerLeftBtn={
                <CloseIcon
                    style={{ color: themes.palette.primary.main }}
                    onClick={() => {
                        props.handleClose();
                    }}
                />
            }
        >
            <div className={classes.optionsContainer}>
                <div>
                    <div className={classes.unlistedBox}>
                        <div className={classes.label}>Only selected consumer can access this style</div>
                        <ClickAwayListener onClickAway={() => setIsShowOptions(false)}>
                            <div
                                className={classes.searchBox}
                                id="user-select"
                                onClick={() => setIsShowOptions((prev) => !prev)}
                            >
                                <SearchIcon />
                                <div style={{ width: '100%' }}>
                                    <input value={valueSearch} onChange={onChangeInput} className={classes.input} />
                                    <div id="scrollableDiv" className={classes.suggestions}>
                                        <InfiniteScroll
                                            dataLength={renderItemSuggestions(suggestions, selectedOptions).length}
                                            next={() => {
                                                setCurrentPage((prev) => prev + 1);
                                                if (getMoreTimeout.current) {
                                                    clearTimeout(getMoreTimeout.current);
                                                }
                                                getMoreTimeout.current = setTimeout(() => {
                                                    fetchMoreData(currentPage + 1);
                                                }, 1500);
                                            }}
                                            hasMore={hasMore}
                                            loader={
                                                <div className={classes.noSuggestions}>
                                                    <Spinner animation="border" style={{ width: 20, height: 20 }} />
                                                </div>
                                            }
                                            scrollableTarget="scrollableDiv"
                                        >
                                            {renderItemSuggestions(suggestions, selectedOptions).length ? (
                                                renderItemSuggestions(suggestions, selectedOptions).map(
                                                    (option, index) => (
                                                        <div
                                                            onClick={() => onSelectOption(option)}
                                                            className={classes.suggestionItem}
                                                            key={`sug-${index}`}
                                                        >
                                                            <img
                                                                src={option.avatar}
                                                                alt=""
                                                                className={classes.suggestionAvatar}
                                                            />
                                                            <div className={classes.suggestionTitle}>
                                                                {option.fullName}
                                                            </div>
                                                        </div>
                                                    ),
                                                )
                                            ) : (
                                                <div className={classes.noSuggestions}>{!hasMore && 'No data'}</div>
                                            )}
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        </ClickAwayListener>
                        <div
                            style={
                                {
                                    // height: `${height - 250}px`
                                }
                            }
                            className={classes.selectedOptions}
                        >
                            {selectedOptions.map((option: any, index) => (
                                <div className={classes.selectedOptionItem} key={`selected-${index}`}>
                                    <img src={option.avatar} alt="" className={classes.suggestionAvatar} />
                                    <div className={classes.selectedOptionTitle}>{option.fullName}</div>
                                    <div>
                                        <CloseIcon
                                            style={{ color: themes.palette.primary.main }}
                                            onClick={() => {
                                                handleDeleteItem(option);
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* <div className={classes.unlistedBox}>
                        <ClickAwayListener onClickAway={() => setIsShowSessions(false)}>
                            <div
                                className={classes.sessionsSearchBox}
                                onClick={() => {
                                    setIsShowSessions((prev) => !prev);
                                }}
                            >
                                <div className={classes.sessionSearchBoxItems}>
                                    <p>Select Session</p>
                                    {isShowSessions ? <ArrowUp /> : <ArrowDown />}
                                </div>
                                <div>
                                    <div id="scrollableSessionsDiv" className={classes.sessionSuggestions}>
                                        <InfiniteScroll
                                            dataLength={
                                                renderItemSuggestions(sessionSuggestions, selectedSessions).length
                                            }
                                            next={() => {
                                                setSessionCurrentPage((prev) => prev + 1);
                                                if (getMoreTimeout.current) {
                                                    clearTimeout(getMoreTimeout.current);
                                                }
                                                getMoreTimeout.current = setTimeout(() => {
                                                    fetchMoreSessions(sessionCurrentPage + 1);
                                                }, 1500);
                                            }}
                                            hasMore={hasMoreSessions}
                                            loader={
                                                <div className={classes.noSuggestions}>
                                                    <Spinner animation="border" style={{ width: 20, height: 20 }} />
                                                </div>
                                            }
                                            scrollableTarget="scrollableSessionsDiv"
                                        >
                                            {renderItemSuggestions(sessionSuggestions, selectedSessions).length ? (
                                                renderItemSuggestions(sessionSuggestions, selectedSessions).map(
                                                    (session: SessionSuggestion, index) => (
                                                        <div
                                                            onClick={() => onSelectSession(session)}
                                                            className={classes.sessionSuggestionItem}
                                                            key={`sug-${index}`}
                                                        >
                                                            <img
                                                                src={session?.customerAvatar}
                                                                alt=""
                                                                className={classes.suggestionAvatar}
                                                            />
                                                            <div className={classes.sessionSuggestionItemBottom}>
                                                                <div className={classes.sessionSuggestionTitle}>
                                                                    {session?.customerFullName}
                                                                </div>
                                                                <h6 className={classes.sessionSuggestionDate}>
                                                                    {session?.startTime}
                                                                </h6>
                                                                {Boolean(session?.stylingSessionReason) && (
                                                                    <p className={classes.sessionSuggestionReason}>
                                                                        {session?.stylingSessionReason}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ),
                                                )
                                            ) : (
                                                <div className={classes.noSuggestions}>
                                                    {!hasMoreSessions && 'No data'}
                                                </div>
                                            )}
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        </ClickAwayListener>
                        <div className={classes.selectedOptions}>
                            {selectedSessions?.map((session: SessionSuggestion, index) => (
                                <div className={classes.selectedOptionItem} key={`selected-${index}`}>
                                    <img src={session?.customerAvatar} alt="" className={classes.suggestionAvatar} />
                                    <div className={classes.sessionSuggestionItemBottom}>
                                        <div className={classes.sessionSuggestionTitle}>
                                            {session?.customerFullName}
                                        </div>
                                        <h6 className={classes.sessionSuggestionDate}>{session?.startTime}</h6>
                                        <p className={classes.sessionSuggestionReason}>
                                            {session?.stylingSessionReason}
                                        </p>
                                    </div>
                                    <div>
                                        <CloseIcon
                                            style={{ color: themes.palette.primary.main }}
                                            onClick={() => {
                                                handleDeleteSession(session);
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div> */}
                </div>
                <div className={classes.buttonPublishBox}>
                    <button
                        onClick={handlePublishPrivate}
                        disabled={!selectedSessions?.length && !props?.consumersIds?.length}
                        className={classes.buttonPublish}
                    >
                        Publish{' '}
                        {props.isSubmitPublishLoading && (
                            <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                        )}
                    </button>
                </div>
            </div>
        </CustomLayout>
    );
};

export default PublishToConsumers;
